import React, { useState } from 'react'
import { supabase } from '../../lib/supabase'

export default function SendEstimateModal({ client, quoteNumber, grandTotal, expiryDate, onClose, onPreviewPDF }) {
  const [toEmail, setToEmail] = useState(client?.email || '')
  const [subject, setSubject] = useState(`Quote from TLC Unlimited — ${new Date().toLocaleDateString('en-US', { month: 'long', day: 'numeric', year: 'numeric' })}`)
  const [message, setMessage] = useState(`Hi ${client?.name || 'there'},\n\nThank you for asking us to quote on your project.\n\nThe quote total is $${grandTotal.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} as of ${new Date().toLocaleDateString()}.\n\nPlease review the attached proposal. A deposit is required to begin work. Don't hesitate to reach out with any questions.\n\nSincerely,\nTLC Unlimited\njohn@tlcunlimitedtx.com\n(915) 603-8202`)
  const [sendCopy, setSendCopy] = useState(false)
  const [sending, setSending] = useState(false)
  const [error, setError] = useState(null)
  const [sent, setSent] = useState(false)
  async function handleSend() {
    if (!toEmail.trim()) return setError('Recipient email is required.')
    setSending(true); setError(null)

    const { error: emailErr } = await supabase.functions.invoke('send-email', {
      body: {
        template: 'estimate_sent',
        to: toEmail.trim(),
        data: {
          client_name: client?.name || 'there',
          job_title: 'Your Project',
          amount: grandTotal.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
          valid_until: expiryDate
            ? new Date(expiryDate + 'T12:00:00').toLocaleDateString('en-US', { month: 'long', day: 'numeric', year: 'numeric' })
            : '',
          portal_link: window.location.origin + '/portal',
          company_email: 'john@tlcunlimitedtx.com',
          company_phone: client?.phone || '',
        }
      }
    })

    if (emailErr) {
      setError('Email failed: ' + emailErr.message)
      setSending(false)
      return
    }

    if (sendCopy) {
      await supabase.functions.invoke('send-email', {
        body: {
          template: 'generic',
          to: 'john@tlcunlimitedtx.com',
          data: {
            subject: 'Copy: Estimate sent to ' + (client?.name || toEmail) + ' — $' + grandTotal.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
            body: 'A copy of Quote #' + quoteNumber + ' has been sent to ' + toEmail + '.<br><br>Total: $' + grandTotal.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
          }
        }
      })
    }

    setSending(false)
    setSent(true)
  }
  if (sent) return (
    <div style={sm.overlay}><div style={sm.modal}><div style={{ textAlign: 'center', padding: '20px 0' }}><div style={{ fontSize: '48px', marginBottom: '12px' }}>✅</div><div style={{ fontSize: '20px', fontWeight: '700', color: '#1a2e1a', marginBottom: '8px' }}>Estimate Sent!</div><div style={{ fontSize: '14px', color: '#6b7c6b', marginBottom: '24px' }}>Proposal sent to {toEmail}</div><button style={sm.sendBtn} onClick={onClose}>Done</button></div></div></div>
  )
  return (
    <div style={sm.overlay}>
      <div style={sm.modal}>
        <div style={sm.header}><h2 style={sm.title}>Send Quote #{quoteNumber} to {client?.name || 'Client'}</h2><button style={sm.closeBtn} onClick={onClose}>✕</button></div>
        {error && <div style={sm.error}>{error}</div>}
        <div style={sm.body}>
          <div style={{ flex: 1 }}>
            <div style={sm.field}><label style={sm.label}>To</label><input style={sm.input} type="email" value={toEmail} onChange={e => setToEmail(e.target.value)} placeholder="client@email.com" /></div>
            <div style={sm.field}><label style={sm.label}>Subject</label><input style={sm.input} value={subject} onChange={e => setSubject(e.target.value)} /></div>
            <div style={sm.field}><label style={sm.label}>Message</label><textarea style={{ ...sm.input, minHeight: '200px', resize: 'vertical' }} value={message} onChange={e => setMessage(e.target.value)} /></div>
            <label style={{ display: 'flex', alignItems: 'center', gap: '8px', cursor: 'pointer', fontSize: '13px', color: '#374151', marginTop: '8px' }}><input type="checkbox" checked={sendCopy} onChange={e => setSendCopy(e.target.checked)} />Send me a copy</label>
            <div style={{ fontSize: '11px', color: '#16a34a', marginTop: '8px', lineHeight: '1.5' }}>✅ Email powered by Resend — client will receive proposal directly to their inbox.</div>
          </div>
          <div style={sm.attachPanel}>
            <div style={sm.attachTitle}>Attachments</div>
            <div style={sm.attachBox}><div style={sm.attachFile}><span style={{ fontSize: '20px' }}>📄</span><div><div style={{ fontSize: '13px', fontWeight: '600', color: '#374151' }}>quote_{quoteNumber}.pdf</div><div style={{ fontSize: '11px', color: '#9ca3af' }}>Generated proposal</div></div></div></div>
            <button style={sm.previewBtn} onClick={onPreviewPDF}>Preview PDF</button>
          </div>
        </div>
        <div style={sm.footer}><button style={sm.cancelBtn} onClick={onClose}>Cancel</button><button style={sm.sendBtn} onClick={handleSend} disabled={sending}>{sending ? 'Sending...' : '✉ Send Email'}</button></div>
      </div>
    </div>
  )
}

const sm = {
  overlay: { position: 'fixed', inset: 0, background: 'rgba(10,20,10,0.55)', backdropFilter: 'blur(4px)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000, padding: '20px' },
  modal: { background: 'white', borderRadius: '14px', padding: '28px', width: '780px', maxWidth: '95vw', maxHeight: '90vh', overflowY: 'auto', boxShadow: '0 20px 60px rgba(0,0,0,0.25)' },
  header: { display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: '20px' },
  title: { margin: 0, fontSize: '17px', fontWeight: '700', color: '#1a2e1a', flex: 1, paddingRight: '12px' },
  closeBtn: { background: 'none', border: 'none', fontSize: '20px', cursor: 'pointer', color: '#6b7c6b', flexShrink: 0 },
  error: { background: '#fef2f2', border: '1px solid #fecaca', borderRadius: '7px', padding: '10px 14px', color: '#dc2626', fontSize: '13px', marginBottom: '16px' },
  body: { display: 'flex', gap: '24px' },
  field: { marginBottom: '14px' },
  label: { display: 'block', fontSize: '11px', fontWeight: '600', color: '#374151', marginBottom: '5px', textTransform: 'uppercase', letterSpacing: '0.5px' },
  input: { width: '100%', padding: '9px 12px', borderRadius: '8px', border: '1.5px solid #d1d5db', fontSize: '14px', fontFamily: 'inherit', boxSizing: 'border-box' },
  attachPanel: { width: '220px', flexShrink: 0 },
  attachTitle: { fontSize: '13px', fontWeight: '700', color: '#374151', marginBottom: '10px' },
  attachBox: { border: '1.5px dashed #d1d5db', borderRadius: '8px', padding: '12px', marginBottom: '10px' },
  attachFile: { display: 'flex', alignItems: 'center', gap: '10px' },
  previewBtn: { width: '100%', background: '#f3f4f6', border: '1.5px solid #d1d5db', color: '#374151', padding: '9px', borderRadius: '8px', fontSize: '13px', fontWeight: '500', cursor: 'pointer', fontFamily: 'inherit', textAlign: 'center' },
  footer: { display: 'flex', gap: '10px', justifyContent: 'flex-end', marginTop: '20px', borderTop: '1px solid #e5e7eb', paddingTop: '16px' },
  cancelBtn: { background: 'none', border: '1.5px solid #d1d5db', color: '#374151', padding: '10px 20px', borderRadius: '8px', fontSize: '14px', fontWeight: '500', cursor: 'pointer', fontFamily: 'inherit' },
  sendBtn: { background: '#2d6a2d', color: 'white', border: 'none', padding: '10px 24px', borderRadius: '8px', fontSize: '14px', fontWeight: '600', cursor: 'pointer', fontFamily: 'inherit' },
}
